angular.module('autoremind.templates')
    .directive('adminTemplatesContent', function () {
    return {
        restrict: 'E',
        templateUrl: 'app/admin/templates/admin-templates-content.html',
        scope: {},
        link: function ($scope, element, attrs) {
            element.addClass('adminTemplatesUsers');
            $scope.viewModel = {
                contentSource: '<template>Some content</template>',
                preview: ''
            };
        }
    };
});
//# sourceMappingURL=admin-templates-content.js.map